<template>
    <div class="medal-block">
        <div class="medals">
            <div class="medal bronze" :class="{won: medalType.toLowerCase() === 'bronze' }"></div>
            <div class="medal silver" :class="{won: medalType.toLowerCase() === 'silver' }"></div>
            <div class="medal gold" :class="{won: medalType.toLowerCase() === 'gold' }"></div>
            <div class="medal platinum" :class="{won: medalType.toLowerCase() === 'platinum' }"></div>
        </div>
        <div class="label">
            Your Result<strong>{{medalType}}</strong>
        </div>
        <div class="info" v-if="medalInfo !== ''" v-html="medalInfo"></div>
    </div>
</template>

<script>
    export default {
        name : "Medal",
        props: {
            medalType: String,
            medalInfo: String
        }
    }
</script>